/**
 * @generated SignedSource<<0c754341dad174530bae6ae2b0ad9010>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type labels_nativeIssueTable_LabelsInlineEditCell_fieldRef$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "labels_nativeIssueTable_LabelsInlineEditCell_fieldRef";
};
export type labels_nativeIssueTable_LabelsInlineEditCell_fieldRef$key = {
  readonly " $data"?: labels_nativeIssueTable_LabelsInlineEditCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"labels_nativeIssueTable_LabelsInlineEditCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "labels_nativeIssueTable_LabelsInlineEditCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraLabelsField"
};

(node as any).hash = "49c05ad05b361adda4504ccab382a01c";

export default node;
